const FirstIcodeItem = (id, partyDetails, item) => {
  const basePrice = item?.RATE ? item?.RATE : item?.PUR_PRICE || 0;
  const totalTax = Number(item.TAX1_RATE) + Number(item.TAX2_RATE);
  const amount = basePrice + (basePrice * totalTax) / 100;
  const hasQuantity = Object.prototype.hasOwnProperty.call(item, "QNTY");
  const qnty = hasQuantity ? item.QNTY : 1;
  const numericQnty = Number(qnty);
  const TAX1_AMOUNT = (basePrice * Number(item.TAX1_RATE)) / 100;
  const TAX2_AMOUNT = (basePrice * Number(item.TAX2_RATE)) / 100;
  return {
    id: id,
    DEBIT_NOTE_NO: partyDetails.DEBIT_NOTE_NO ? partyDetails.DEBIT_NOTE_NO : "",
    DATE: partyDetails.DATE,
    ACCOUNT_NO: item.ACCOUNT_NO,
    NAME: item.NAME,
    INVNO: item.INVNO,
    PUR_BILL_NO: item.PUR_BILL_NO,
    TOTAL: 0,
    GTOTAL: 0,
    REMARKS: item?.REMARKS ? item.REMARKS : "",
    ICODE: item?.ICODE ? item.ICODE : "",
    ITEMNAME: item?.ITEMNAME ? item.ITEMNAME : "",
    QNTY: qnty,
    RATE: item?.RATE ? item?.RATE : item?.PUR_PRICE || 0,
    AMOUNT: Number.isFinite(numericQnty)
      ? Number((amount * numericQnty).toFixed(2))
      : 0,
    HSN_CODE: item.HSN_CODE,
    TAX1_RATE: item.TAX1_RATE,
    TAX1_AMOUNT: Number.isFinite(numericQnty)
      ? Number((TAX1_AMOUNT * numericQnty).toFixed(2))
      : 0,
    TAX2_RATE: item.TAX2_RATE,
    TAX2_AMOUNT: Number.isFinite(numericQnty)
      ? Number((TAX2_AMOUNT * numericQnty).toFixed(2))
      : 0,
    UNIT: item.UNIT,
    PACKING: item.PACKING,
  };
};

export default FirstIcodeItem;
